import { render, staticRenderFns } from "./preview-customerinvoice.vue?vue&type=template&id=2d24a985&scoped=true&"
import script from "./preview-customerinvoice.vue?vue&type=script&lang=js&"
export * from "./preview-customerinvoice.vue?vue&type=script&lang=js&"
import style0 from "./preview-customerinvoice.vue?vue&type=style&index=0&id=2d24a985&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d24a985",
  null
  
)

export default component.exports